import clock from "#/src/assets/svg/clock.svg";
import {ApiArticle} from "#/src/definitions/ApiDefinitions";
import {Link} from "#/src/components/Link";
import {truncateTitle} from "#/src/utils/string-utils";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {TimeDisplay} from "#/src/components/TimeDisplay";
import {getProfileUrl} from "#/src/utils/profile-url";
import {ClickableWrapper} from "#/src/components/ClickableWrapper";
import {navigate} from "vike/client/router";
import {AdArticleCard} from "#/src/components/AdArticleCard";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";

interface Props {
  article: ApiArticle,
  size?: "high" | "medium" | "small",
  lazy?: boolean
}

export function ArticleCard({article, size = "small", lazy = false}: Props) {
  if(article.isAd) {
    return <AdArticleCard article={article} lazy={lazy}/>
  }
  return <ClickableWrapper onClick={() => navigate(`/blog/${article.slug}`)}>
    <article className="article-card">
      <figure className="article-img">
        <img loading={lazy ? "lazy" : "eager"} src={Attachments.getUrl(AttachmentNamespace.ARTICLE, article) + `-${size}`} alt={article.slug}/>
      </figure>
      <div className="article-content">
        <div className="article-tag">
          <a href={`/blog${article.category.active ? `?category=${article.category.slug}` : ""}`} className="tag-primary">{article.category.name}</a>
        </div>
        <Link href={`/blog/${article.slug}`} className="article-link">{truncateTitle(article.title)}</Link>
        <div className="article-author mt-2">
          <div className="author">
            <AvatarWithFallback user={article.author} className={"avatar avatar-20"} lazy={lazy}/>
            <a href={getProfileUrl(article.author)} className="author-link">{article.author.username}</a>
          </div>
          <div className="article-date text-nowrap">
            <img src={clock} alt="Icon"/>
            <span><TimeDisplay className={"ms-2"} date={article.creationDate}/></span>
          </div>
        </div>
      </div>
    </article>
  </ClickableWrapper>
}